









import { Component, Vue } from 'vue-property-decorator'
import 'semantic-ui-css/components/container.min.css'
import 'semantic-ui-css/components/segment.min.css'
import 'animate.css/source/fading_entrances/fadeIn.css'

@Component
export default class LCTail extends Vue {}
